import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error-modal-hero",
  "use": "icon-error-modal-hero-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-error-modal-hero\">\n<circle cx=\"24\" cy=\"24\" r=\"24\" fill=\"#F64963\" />\n<path d=\"M24 28L24 14\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<circle cx=\"2\" cy=\"2\" r=\"2\" transform=\"matrix(1 0 0 -1 22 36)\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol